import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Ng2StateDeclaration, UIRouterModule } from '@uirouter/angular';
import { CandidateProfilePageComponent } from './candidateprofile-page.component';
import { CandidateProfileModule } from './candidate-profile/candidate-profile.module';

const states: Ng2StateDeclaration[] = [
  {
    name: 'missioncontrol.candidateprofile',
    url: '/candidateProfile',
    component: CandidateProfilePageComponent,
    data: {
      requireLogin: true
    },
    params: {
      candidateId: null
    }
  }
];

@NgModule({
  declarations: [CandidateProfilePageComponent],
  imports: [
    CommonModule,
    CandidateProfileModule,
    UIRouterModule.forChild({ states })
  ],
  entryComponents: [CandidateProfilePageComponent],
  exports: [CandidateProfilePageComponent]
})
export class CandidateProfilePageModule { }
